import Box from '@mui/material/Box';
import {
  getGroupDisplayColor,
  getGroupFeature,
  ProductGroup as Group,
  Subscription,
} from '../../../models';
import { SubscriptionGroup } from './SubscriptionGroup';

export const DetailSubscriptionGroup = (
  { subscriptions }: { subscriptions: Subscription[] },
) => (
  <Box
    id="current-subscription"
    key="current-subscription"
    display="flex"
    flexDirection="column"
    flexWrap="wrap"
    width="100%"
    sx={theme => ({
      [theme.breakpoints.down('tablet')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.up('tablet')]: {
        flexDirection: 'row',
      },
    })}
  >
    {Object.entries(Group).map(([, group]) => {
      const features = getGroupFeature(group);
      const groupSubscriptions = subscriptions.filter(
        subscription => features.includes(subscription.feature),
      );
      if (groupSubscriptions.length === 0) {
        return null;
      }

      return groupSubscriptions.length > 0
        ? (
          <SubscriptionGroup
            key={`group-${group}`}
            groupId={group}
            color={getGroupDisplayColor(group)}
            subscriptions={groupSubscriptions}
          />
        )
        : null;
    })}
  </Box>
);
